import { LoaderScreen } from '@/components/Elements/LoaderScreen';
import { FrontchannelLogoutEffect } from '@/features/auth/components/FrontchannelLogoutEffect';
import { ErrorScreen } from '@/pages/ErrorScreen';
import { createBrowserRouter, Outlet } from 'react-router';
import { privateRoutes } from './private';
import { publicRoutes } from './public';

export const appRouter = createBrowserRouter([
  {
    HydrateFallback: LoaderScreen,
    element: (
      <FrontchannelLogoutEffect>
        <Outlet />
      </FrontchannelLogoutEffect>
    ),
    errorElement: <ErrorScreen />,
    children: [...publicRoutes, ...privateRoutes],
  },
]);
